import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m14.571 17.143 4.286 6m-9.428-6-4.286 6m-4.286-6h22.286m-18-12.857h13.714A1.714 1.714 0 0 1 20.571 6v11.143H3.43V6a1.714 1.714 0 0 1 1.714-1.714v0Zm6.857 0V.857",
		stroke: "#262626",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22m14.571%2017.143%204.286%206m-9.428-6-4.286%206m-4.286-6h22.286m-18-12.857h13.714A1.714%201.714%200%200%201%2020.571%206v11.143H3.43V6a1.714%201.714%200%200%201%201.714-1.714v0Zm6.857%200V.857%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
